import { type ReactNode } from 'react';

import { type PlanGroupSubType, useActiveSessionStore } from './activeSessionStore';

interface ActiveSessionProviderProps {
  accountId: string;
  userId: string;
  partnerId: string;
  planGroupSubType?: PlanGroupSubType;
  isMobile: boolean;
  isModular: boolean;
  shouldShowWelcome: boolean;
  csrfToken: string;
  children: ReactNode;
}

const ActiveSessionProvider = ({
  accountId,
  userId,
  partnerId,
  planGroupSubType,
  isMobile,
  isModular,
  shouldShowWelcome,
  csrfToken,
  children,
}: ActiveSessionProviderProps) => {
  useActiveSessionStore.setState({
    accountId: Number(accountId),
    userId,
    partnerId: Number(partnerId),
    planGroupSubType: planGroupSubType ?? null,
    isMobile,
    isModular,
    csrfToken,
    shouldShowWelcome,
  });
  return children;
};

export { ActiveSessionProvider };
export type { ActiveSessionProviderProps };
